import t from "react";
import { useStyle as c } from "../../../features/dom/hooks/useStyle.js";
import { useWindowSize as g } from "../../../features/dom/hooks/useWindowSize.js";
import { Background as s } from "../../../features/common/components/Background/Background.js";
import { SharedLandingProvider as d } from "./hooks/useSharedLanding/context.js";
import { SharedLandingGlobalModal as m } from "./components/GlobalModal/globalModal.js";
import o from "./shared-landing.module.scss.js";
function h(n) {
  const {
    design: e,
    backgroundImage: r,
    background640x1100: a,
    children: l
  } = n, {
    height: i
  } = g();
  return c("https://statics.cheerfy.com/admin/css/fonts/lineicons/LineIconsCustom.css"), /* @__PURE__ */ t.createElement(
    "div",
    {
      className: o.landing,
      "data-testid": "shared-landing-shell",
      style: {
        "--general-background-color": e.general.background,
        "--general-text-color": e.general.text,
        "--general-line-color": e.general.lines,
        "--highlight-background-color": e.general.highlightBackground,
        "--highlight-text-color": e.general.highlightText,
        "--highlight-line-color": e.general.highlightLines,
        "--primary-button-background-color": e.general.primaryButtonBackground,
        "--primary-button-text-color": e.general.primaryButtonText,
        "--secondary-button-background-color": e.general.secondaryButtonBackground,
        "--secondary-button-text-color": e.general.secondaryButtonText,
        fontFamily: `'${e.font}', 'Quicksand', 'monospace'`,
        height: i
      }
    },
    /* @__PURE__ */ t.createElement("link", { rel: "stylesheet", href: `https://fonts.googleapis.com/css2?family=${e.font}:wght@300;400;700&display=swap` }),
    /* @__PURE__ */ t.createElement(
      s,
      {
        image: r,
        imageResponsive: a,
        backdropColor: e.startPage.opacityLayer
      },
      /* @__PURE__ */ t.createElement("div", { className: o.landing__center }, /* @__PURE__ */ t.createElement(m, null), l)
    )
  );
}
function B(n) {
  const { design: e } = n;
  return /* @__PURE__ */ t.createElement(d, { design: e }, /* @__PURE__ */ t.createElement(h, { ...n }));
}
export {
  h as LandingShellRoot,
  B as SharedLandingShell
};
//# sourceMappingURL=SharedLandingShell.js.map
